import React from 'react'
import Image from 'next/image'
import { Box, Container, Group, Space, Stack } from '@mantine/core'
import { KnockLogo } from '@phoenix-web/icons-images'
import CoupleHangingPicture from '@phoenix-web/icons-images/svgs/CoupleHangingPicture.svg'

export default function AuthLandingLayout({
  children,
  hideLogo,
  invertLayout = false,
  minHeight = '90dvh',
}: {
  children: React.ReactNode
  hideLogo?: boolean
  invertLayout?: boolean
  minHeight?: string
}) {
  return (
    <Container size="lg">
      <Group mih={minHeight} w="100%" align="center" wrap="nowrap" gap="md">
        {/* Sign up Image */}
        <Box style={{ order: invertLayout ? 2 : 1 }} w="50%" visibleFrom="md">
          <Space h="xxl" />
          <Space h="xxl" />
          <Image src={CoupleHangingPicture} unoptimized style={{ width: '100%' }} alt="Couple hanging a picture" />
        </Box>

        {/* Audience Selector and Partner Sign Up Form */}
        <Stack style={{ order: invertLayout ? 1 : 2 }} w={{ base: '100%', md: '50%' }} align="center" justify="center">
          {!hideLogo && (
            <Box mt="xl">
              <KnockLogo height="50" />
            </Box>
          )}
          {children}
        </Stack>
      </Group>
    </Container>
  )
}

export const AuthContainerWrapper = ({ children }: { children: React.ReactNode }) => (
  <Container
    ta="center"
    bg="white"
    p="xl"
    mt="xl"
    maw={456}
    w={{ base: '100%', md: 456 }}
    bd="1px solid var(--mantine-color-gray-2)"
    style={{
      borderRadius: 'var(--mantine-radius-md)',
    }}
  >
    <Box mt="xl">
      <KnockLogo height="50" />
    </Box>
    {children}
  </Container>
)
